export const SPACEBAR_KEYCODE = 32;
export const ENTER_KEYCODE = 13;
export const UP_ARROW_KEYCODE = 38;
export const DOWN_ARROW_KEYCODE = 40;
export const LEFT_ARROW_KEYCODE = 37;
export const RIGHT_ARROY_KEYYCODE = 39;
export const ESC_KEYCODE = 27;
export const TAB_KEYCODE = 9;
